module.exports = __webpack_public_path__ + "static/media/二维码_副本.e06187b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_173/img/二维码_副本.png
// module id = 1601
// module chunks = 0